export default __webpack_public_path__ + "static/media/ic_color_notification.9f4c4a8b.png";